// 📁 Imports
import * as libphonenumber from "libphonenumber-js";
const {
  parsePhoneNumberFromString,
  AsYouType,
  findNumbers,
  getCountryCallingCode,
} = libphonenumber;
import { isPhoneWithCountryCode } from "@/utils/input-validator.js";

// 💾 Variables
const inputsPhone = document.querySelectorAll(
  "[data-input-phone-country-wrapper]",
);
const inputsPhoneFormat = document.querySelectorAll(
  "[data-validate-phone-format]",
);

const inputPhoneMenuOptions = document.querySelectorAll(
  "[data-input-phone-option]",
);
const inputPhoneMenuShowClass = "select-phone__menu--open";

// 📐 Functions
// MENU
// Open phone menu
const openInputMenu = (InputWrapper) => {
  const inputPhoneMenu = InputWrapper.querySelector("[data-input-phone-menu]");
  inputPhoneMenu.classList.add(inputPhoneMenuShowClass);
};

// Open/Close (toggle) phone menu
const toggleInputMenu = (InputWrapper) => {
  const inputPhoneMenu = InputWrapper.querySelector("[data-input-phone-menu]");
  inputPhoneMenu.classList.toggle(inputPhoneMenuShowClass);
};

// Close phone menu
const closeInputMenu = (InputWrapper) => {
  const inputPhoneMenu = InputWrapper.querySelector("[data-input-phone-menu]");
  inputPhoneMenu.classList.remove(inputPhoneMenuShowClass);
  const input = InputWrapper.querySelector("[data-validate-phone-format]");
  const valueHasNational = parsePhoneNumberFromString(input.value.trim());

  if (
    valueHasNational &&
    input.dataset.inputValidatePhoneCountryCode !== "INTERNATIONAL"
  ) {
    const updateNationalValue = `${input.dataset.inputValidatePhoneCountryCode}${parsePhoneNumberFromString(input.value.trim()).nationalNumber}`;
    input.value = updateNationalValue;
  }

  if (
    input.value.length !== 0 &&
    input.dataset.inputValidatePhoneCountryCode !== "INTERNATIONAL"
  ) {
    const inputEvent = new Event("input", {
      bubbles: true,
      cancelable: true,
    });

    input.dispatchEvent(inputEvent);
  }

  if (
    input.dataset.inputValidatePhoneCountryCode === "INTERNATIONAL" &&
    input.value.length !== 0
  ) {
    isPhoneWithCountryCode(input.value, input);
  }
};

// Close all phone menu
const closeAllInputMenu = (InputsWrapper) => {
  InputsWrapper.forEach((InputWrapper) => {
    const inputPhoneMenu = InputWrapper.querySelector(
      "[data-input-phone-menu]",
    );

    inputPhoneMenu.classList.remove(inputPhoneMenuShowClass);
  });
};

// Update active option
const updateActiveOption = (currentLang, select) => {
  const activeClass = "hidden";
  const allItems = select.querySelectorAll(
    `[data-input-phone-option-checkmark]`,
  );

  const activeItem = select.querySelector(
    `[data-input-phone-option-value-country=${currentLang}]`,
  );

  Array.from(allItems).forEach((option) => {
    option.classList.add(activeClass);
  });

  if (activeItem) {
    const flagItem = activeItem.parentElement.querySelector(
      "[data-input-phone-option-checkmark]",
    );

    flagItem.classList.remove(activeClass);
  } else {
    const internationalItem = select.querySelector(
      `[data-input-phone-option-value-country="INTERNATIONAL"] [data-input-phone-option-checkmark]`,
    );

    internationalItem.classList.remove(activeClass);
  }
};

// Update country code
const updateCountryCode = (country, value, select) => {
  const countryCodeFlag = country;

  const currentValueCodeElement = select.querySelector(
    "[data-input-phone-option-value-current]",
  );
  const currentFlag = select.querySelector(
    "[data-input-phone-option-flag-current] svg",
  );
  const phoneInput = select.querySelector("[data-validate-phone-format]");

  const newValue = value;

  const newFlag = select.querySelector(
    `[data-input-phone-option-value-country=${countryCodeFlag}] [data-input-phone-option-value-flag]`,
  );

  const internationalFlag = select.querySelector(
    `[data-input-phone-option-value-country="INTERNATIONAL"] [data-input-phone-option-value-flag]`,
  );

  // Update flag
  if (newFlag && currentFlag) {
    const clonedFlag = newFlag.cloneNode(true);
    clonedFlag.setAttribute("width", "20");
    clonedFlag.setAttribute("height", "15");
    currentFlag.replaceWith(clonedFlag);

    currentValueCodeElement.dataset.inputPhoneOptionValueCurrent = country;
    phoneInput.dataset.inputValidatePhoneCountry = country;
    phoneInput.dataset.inputValidatePhoneCountryCode = value;
  } else {
    const clonedFlag = internationalFlag.cloneNode(true);
    clonedFlag.setAttribute("width", "20");
    clonedFlag.setAttribute("height", "15");
    currentFlag.replaceWith(clonedFlag);

    currentValueCodeElement.dataset.inputPhoneOptionValueCurrent = country;
    phoneInput.dataset.inputValidatePhoneCountry = country;
    phoneInput.dataset.inputValidatePhoneCountryCode = value;
  }

  // Update country code
  if (currentValueCodeElement && newValue) {
    currentValueCodeElement.textContent = newValue;
  }
  if (country === "INTERNATIONAL") {
    currentValueCodeElement.textContent = "-";
    phoneInput.dataset.inputValidatePhoneCountryCode = "INTERNATIONAL";
  }

  closeInputMenu(select);
};

// AutoCountry detector (on input typing)
const numberCountryDetector = (value, select, input) => {
  const asYouType = new AsYouType();
  const formattedValue = asYouType.input(value.trim());
  const getCountryValue = asYouType.getNumber(formattedValue);

  if (getCountryValue !== undefined) {
    const currentValueCodeElement = select.querySelector(
      "[data-input-phone-option-value-current]",
    );

    const currentFlag = select.querySelector(
      "[data-input-phone-option-flag-current] svg",
    );
    const newFlag = select.querySelector(
      `[data-input-phone-option-value-country=${getCountryValue.country}] [data-input-phone-option-value-flag]`,
    );

    const internationaFlag = select.querySelector(
      `[data-input-phone-option-value-country="INTERNATIONAL"] [data-input-phone-option-value-flag]`,
    );

    if (newFlag && currentFlag) {
      const clonedFlag = newFlag.cloneNode(true);
      clonedFlag.setAttribute("width", "20");
      clonedFlag.setAttribute("height", "15");
      currentFlag.replaceWith(clonedFlag);
    } else {
      const clonedFlag = internationaFlag.cloneNode(true);
      clonedFlag.setAttribute("width", "20");
      clonedFlag.setAttribute("height", "15");
      currentFlag.replaceWith(clonedFlag);
    }

    if (currentValueCodeElement) {
      currentValueCodeElement.textContent = `+${getCountryValue.countryCallingCode}`;
    }

    input.value = getCountryValue.nationalNumber;
    input.dataset.inputValidatePhoneCountryCode = `+${getCountryValue.countryCallingCode}`;
    input.dataset.inputValidatePhoneCountry = getCountryValue.country;
    updateActiveOption(getCountryValue.country, select);
  }
};

// Init country code
const initCountryCode = (phoneInput) => {
  const inputPhoneValue = phoneInput.querySelector(
    "[data-input-phone-value]",
  ).value;
  const defaultLangData = phoneInput.querySelector("[data-lang]");
  const possibleNumbers = findNumbers(inputPhoneValue.trim(), null);

  if (possibleNumbers.length !== 0 && inputPhoneValue.length !== 0) {
    const phoneNumber = parsePhoneNumberFromString(inputPhoneValue);
    const country = phoneNumber.country;
    const value = phoneNumber.countryCallingCode;

    updateCountryCode(country, `+${value}`, phoneInput);
    updateActiveOption(country, phoneInput);
  } else {
    updateCountryCode("INTERNATIONAL", "-", phoneInput);
    updateActiveOption("INTERNATIONAL", phoneInput);
  }

  if (inputPhoneValue.length === 0 && defaultLangData) {
    const initLang = defaultLangData.dataset.lang.toUpperCase();
    const value = getCountryCallingCode(initLang);
    updateCountryCode(initLang, `+${value}`, phoneInput);
    updateActiveOption(initLang, phoneInput);
  }
};

// Init value
const initValue = (select) => {
  const inputHidden = select.querySelector("[data-input-phone-value]");
  const input = select.querySelector("[data-validate-phone-format]");
  const currentValue = inputHidden.value;

  const asYouType = new AsYouType();
  const formattedValue = asYouType.input(currentValue.trim());
  const getCountryValue = asYouType.getNumber(formattedValue);

  if (getCountryValue) {
    input.value = getCountryValue.nationalNumber;
  }
};

// 🖱️ Event listener
if (inputsPhone.length !== 0) {
  inputsPhone.forEach((inputPhone) => {
    initCountryCode(inputPhone);
    initValue(inputPhone);

    const inputPhoneTriggerOpen = inputPhone.querySelector(
      "[data-input-phone-trigger-open]",
    );

    inputPhoneTriggerOpen.addEventListener("click", () => {
      toggleInputMenu(inputPhone);
    });
  });

  // Close default
  document.body.addEventListener("click", (e) => {
    if (e.target.closest("[data-input-phone-trigger-open]")) {
      return;
    }

    if (!e.target.closest("[data-input-phone-menu]")) {
      closeAllInputMenu(inputsPhone);
    }
  });
}

if (inputPhoneMenuOptions.length !== 0) {
  inputPhoneMenuOptions.forEach((option) => {
    const selectCurrent = option.closest("[data-input-phone-country-wrapper]");
    option.addEventListener("click", (e) => {
      const country = e.currentTarget.dataset.inputPhoneOptionValueCountry;
      const value = e.currentTarget.dataset.inputPhoneOptionValue;
      updateActiveOption(
        e.currentTarget.dataset.inputPhoneOptionValueCountry,
        selectCurrent,
      );
      updateCountryCode(country, value, selectCurrent);
    });
  });
}

if (inputsPhoneFormat.length !== 0) {
  inputsPhoneFormat.forEach((input) => {
    const selectCurrent = input.closest("[data-input-phone-country-wrapper]");
    input.addEventListener("input", (e) => {
      const value = e.target.value;
      const input = e.target;
      numberCountryDetector(value, selectCurrent, input);
    });
  });
}
